import { render } from "./CategorySubCatPageView.vue?vue&type=template&id=11b649dc"
import script from "./CategorySubCatPageView.vue?vue&type=script&lang=js"
export * from "./CategorySubCatPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__